// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bcyd","question":"styles_question__24SN5","description":"styles_description__tInvd"};